/**
 * @generated SignedSource<<006de83998195f0064c11fa6bb106d9f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PostVoteType = "DOWN" | "NONE" | "UP" | "%future added value";
export type commentPreviewCreateCommentVoteMutation$variables = {
  commentId: string;
  vote: PostVoteType;
};
export type commentPreviewCreateCommentVoteMutation$data = {
  readonly registerCommentVote: {
    readonly " $fragmentSpreads": FragmentRefs<"commentPreviewFragment">;
  };
};
export type commentPreviewCreateCommentVoteMutation = {
  response: commentPreviewCreateCommentVoteMutation$data;
  variables: commentPreviewCreateCommentVoteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "commentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "vote"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "commentId",
    "variableName": "commentId"
  },
  {
    "kind": "Variable",
    "name": "vote",
    "variableName": "vote"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "commentPreviewCreateCommentVoteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "registerCommentVote",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "commentPreviewFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "commentPreviewCreateCommentVoteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "registerCommentVote",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isCommentInterface"
          },
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "content",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "author",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "avatarFallback",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ImageFile",
                "kind": "LinkedField",
                "name": "photo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "signedUrl",
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "votes",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CommentVote",
            "kind": "LinkedField",
            "name": "userVote",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vote",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Post",
                "kind": "LinkedField",
                "name": "post",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v5/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Comment",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Event",
                "kind": "LinkedField",
                "name": "event",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "EventComment",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "11b79a18a549e1b1e7810e8291418a10",
    "id": null,
    "metadata": {},
    "name": "commentPreviewCreateCommentVoteMutation",
    "operationKind": "mutation",
    "text": "mutation commentPreviewCreateCommentVoteMutation(\n  $commentId: ID!\n  $vote: PostVoteType!\n) {\n  registerCommentVote(commentId: $commentId, vote: $vote) {\n    __typename\n    ...commentPreviewFragment\n    id\n  }\n}\n\nfragment commentPreviewFragment on CommentInterface {\n  __isCommentInterface: __typename\n  id\n  content\n  author {\n    id\n    displayName\n    avatarFallback\n    photo {\n      signedUrl\n      id\n    }\n  }\n  votes\n  userVote {\n    vote\n  }\n  ... on Comment {\n    post {\n      title\n      slug\n      space {\n        __typename\n        slug\n        id\n      }\n      id\n    }\n  }\n  ... on EventComment {\n    event {\n      title\n      slug\n      id\n    }\n  }\n  __typename\n}\n"
  }
};
})();

(node as any).hash = "5574c724e51c2292b14d4393789a0da5";

export default node;
